import { render, staticRenderFns } from "./WalletToBank.vue?vue&type=template&id=492f5c50"
import script from "./WalletToBank.vue?vue&type=script&lang=js"
export * from "./WalletToBank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports